/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _isArray from 'lodash/isArray';
import _map from 'lodash/map';
import { addItemToStack } from '../../../analytics';
import { formatBasePrice } from '../../../analytics/formatPrice';

export default (set, get, sku, basePrice = null) => set(
  produce(
    get(), (draft) => {
      if (!draft.digitalData) {
        draft.digitalData = { event: [] };
      }

      if (_isArray(sku)) {
        const trackAddBundleToStack = {
          items: _map(sku, (skuAndPrice) => ({
            sku: `${skuAndPrice?.sku}`,
            quantity: skuAndPrice?.quantity || 1,
            price: { basePrice: formatBasePrice(skuAndPrice?.basePrice) }
          })),
          primaryCategory: 'button submission',
          eventName: 'bundle add'
        };
        draft.digitalData.addItemToStack = trackAddBundleToStack;

        return addItemToStack(trackAddBundleToStack);
      }

      const trackAddItemToStack = {
        items: [{
          sku,
          price: { basePrice: formatBasePrice(basePrice) },
          quantity: 1
        }],
        primaryCategory: 'button submission',
        eventName: 'bundle add'
      };

      draft.digitalData.addItemToStack = trackAddItemToStack;

      return addItemToStack(trackAddItemToStack);
    }),
  false,
  { type: 'TRACK_ADD_ITEM_TO_STACK' }
);
